module.exports = __webpack_public_path__ + "static/media/div4.0dd27bce.jpg";